"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { buildEmailSuggestionInsertContent } from "../../editor/email-mention";
import { useState } from "react";
import { LuAtSign } from "react-icons/lu";
import { TemplateVariableModal } from "@/components/tiptap/template-variable-modal";
import { Button } from "@/components/ui";
import type { SuggestionItem } from "@/types/suggestions";
import { HSeparator } from "./h-separator";

/**
 * "Insert variable" action for the email composer: an icon-only toolbar button
 * ({} glyph + tooltip) rendered after the formatting cluster, set apart by a
 * divider. Placement is handled by the toolbar; this just renders the button +
 * modal.
 *
 * Opens the shared TemplateVariableModal and inserts through the same builder
 * as `@`-typing, so both entry points honour the composer's `resolveOnInsert`.
 * Renders nothing when the composer has no variables (the same gate the old
 * toolbar button used).
 */
export function InsertVariableBar() {
  const $ = _c(10);
  const {
    editor,
    variables,
    resolveOnInsert
  } = useEmailComposer();
  const [open, setOpen] = useState(false);
  if (!editor || variables.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== editor || $[1] !== resolveOnInsert) {
    t0 = item => {
      editor.chain().focus().insertContent(buildEmailSuggestionInsertContent(item, {
        resolveOnInsert
      })).run();
      trackEmailComposerAction("variable_inserted", "toolbar");
      setOpen(false);
    };
    $[0] = editor;
    $[1] = resolveOnInsert;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const handleSelect = t0;
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HSeparator />;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button type="button" variant="ghost" size="icon-sm" icon={<LuAtSign size={16} />} onClick={() => setOpen(true)} tooltip="Insert variable" />;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== handleSelect || $[6] !== open || $[7] !== resolveOnInsert || $[8] !== variables) {
    t3 = <>{t1}{t2}<TemplateVariableModal open={open} onOpenChange={setOpen} suggestions={variables} onSelect={handleSelect} insertsText={resolveOnInsert} /></>;
    $[5] = handleSelect;
    $[6] = open;
    $[7] = resolveOnInsert;
    $[8] = variables;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}